var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pdf-preview-container" },
    [
      _c("PdfPreviewToolbarComponent", {
        ref: "toolbar",
        attrs: { totalNumberOfPages: _vm.totalNumberOfPages },
        on: {
          "next-page-event": _vm.goToNextPage,
          "previous-page-event": _vm.goToPreviousPage,
          "close-viewer-event": _vm.closeViewerEvent,
        },
      }),
      _c("PdfPreviewMagnificationComponent", {
        on: {
          "page-fit-event": _vm.pageFit,
          "zoom-in-event": _vm.zoomIn,
          "zoom-out-event": _vm.zoomOut,
        },
      }),
      !_vm.isLoading
        ? _c("ejs-pdfviewer", {
            ref: "pdfViewer",
            attrs: {
              id: "pdf-viewer",
              documentPath: "empty.pdf",
              serviceUrl: _vm.serviceUrl,
              documentLoad: _vm.onDocumentLoad,
              ajaxRequestInitiate: _vm.onAjaxRequestInit,
              enableToolbar: false,
              enableThumbnail: false,
              enableNavigationToolbar: false,
              ajaxRequestFailed: _vm.onServiceFailure,
              documentLoadFailed: _vm.onServiceFailure,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }